import { useState } from "react";
import { useLocation } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { toast } from "react-toastify";
import "./ContactSupport.css";

function ContactSupport() {
  const { state } = useLocation();
  const booking = state?.booking;

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitForm = (e) => {
    e.preventDefault();

    axiosClient
      .post("/support/contact", {
        ...form,
        bookingId: booking?._id,
        bikeName: booking?.bikeId?.name,
        amount: booking?.totalAmount,
      })
      .then(() => {
        toast.success("Support request sent successfully");
        setForm({ name: "", email: "", message: "" });
      })
      .catch(() => toast.error("Failed to send support request"));
  };

  return (
    <div className="contact-page">
      <div className="contact-container reveal active">
        <div className="contact-header">
          <h2>Contact <span>Support</span></h2>
          <p>We're here to help! Please drop us a message below.</p>
        </div>

        {booking && (
          <div className="booking-ref-card">
            <p><strong>Booking ID:</strong> {booking._id}</p>
            <p><strong>Bike:</strong> {booking.bikeId?.name}</p>
            <p><strong>Amount Paid:</strong> ₹{booking.totalAmount}</p>
          </div>
        )}

        <form onSubmit={submitForm} className="contact-form">
          <input
            className="contact-input"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <input
            className="contact-input"
            name="email"
            type="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <textarea
            className="contact-input"
            name="message"
            placeholder="Explain your issue in detail"
            value={form.message}
            onChange={handleChange}
            required
          />

          <button className="contact-submit" type="submit">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactSupport;
